const EventTypes = {
    OPEN_SIDEBAR: 'OPEN_SIDEBAR',
    CLOSE_SIDEBAR: 'CLOSE_SIDEBAR',
    RESIZE_WINDOW: 'RESIZE_WINDOW',
    UPDATE_UNIT_SYSTEM: 'UPDATE_UNIT_SYSTEM',
    UPDATE_ELEMENT_SHAPE: 'UPDATE_ELEMENT_SHAPE',
    UPDATE_ELEMENT_LABELS: 'UPDATE_ELEMENT_LABELS',
}

export default EventTypes;
